import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const userCreationsAdapter = createEntityAdapter({})

const initialState = userCreationsAdapter.getInitialState()

export const userCreationsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserCreations: builder.query({
            query: () => ({
                url: '/userCreations/getUserCreations',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),

            // 26 Jan 2026
            transformResponse: (responseData) => {

                // 🟢 Sponsor path → backend sends object
                if (responseData?.creations) {
                    return {
                    creations: responseData.creations.map((c) => ({
                        ...c,
                        id: c._id,
                    })),
                    orgDailyTotals: responseData.orgDailyTotals || [],
                    orgUserDailyTotals: responseData.orgUserDailyTotals || [], // 31 Jan 2026
                    };
                }

                // 🟢 Non-sponsor / legacy path → backend sends array
                if (Array.isArray(responseData)) {
                    return responseData.map((c) => ({
                    ...c,
                    id: c._id,
                    }));
                }

                // 🟢 Fallback safety
                return [];
            },
            providesTags: (result) => {
                const creations = Array.isArray(result)
                    ? result
                    : result?.creations || [];

                return [
                    { type: 'UserCreation', id: 'LIST' },
                    ...creations.map((c) => ({
                    type: 'UserCreation',
                    id: c._id,
                    })),
                ];
            },

            // 26 Jan 2026 - Commented for Purpose Native Universe - DO NOT DELETE - KEPT FOR REFERENCE
            // transformResponse: responseData => {
            //     const loadedUserCreations = responseData.map(userCreation => {
            //         userCreation.id = userCreation._id
            //         return userCreation
            //     })
            //     return userCreationsAdapter.setAll(initialState, loadedUserCreations)
            // },
            // providesTags: (result, error, arg) => {
            //     if(result?.ids) {
            //         return [
            //             {type: 'UserCreation', id: 'LIST'},
            //             ...result.ids.map(id => ({ type: 'UserCreation', id}))
            //         ]
            //     } else {
            //         return [ { type: 'UserCreation', id: 'LIST'}]
            //     }
            // },
        }),
        createNewUserCreation: builder.mutation({
            query: initialUserCreation => ({
                url: '/userCreations/createNewUserCreation',
                method: 'POST',
                body: {...initialUserCreation,}
            }),
            invalidatesTags: [
                { type: 'UserCreation', id: "LIST" }
            ] 
        }),
        updateUserCreation: builder.mutation({
            query: initialUserCreation => ({
                url: '/userCreations/updateUserCreation',
                method: 'PATCH',
                body: {...initialUserCreation,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserCreation', id: arg.id },
                { type: 'UserCreation', id: 'LIST' }
            ],
        }),
        deleteUserCreation: builder.mutation({
            query: (deletionPayload) => ({
                url: '/userCreations/deleteUserCreation',
                method: 'DELETE',
                body: deletionPayload
            }),
            // query: ({id}) => ({
            //     url: '/userCreations/deleteUserCreation',
            //     method: 'DELETE',
            //     body: {id}
            // }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserCreation', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserCreationsQuery,
    useCreateNewUserCreationMutation,
    useUpdateUserCreationMutation,
    useDeleteUserCreationMutation,
} = userCreationsApiSlice

// returns the query result object
export const selectUserCreationResult = userCreationsApiSlice.endpoints.getUserCreations.select()

// create memoized selector
const selectUserCreationsData = createSelector(
    selectUserCreationResult,
    userCreationResult => userCreationResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserCreations,
    selectById: selectUserCreationById,
    selectIds: selectUserCreationIds,
} = userCreationsAdapter.getSelectors(state => selectUserCreationsData(state) ?? initialState)